import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from "react-dom";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { useShouldInitOverlay } from "../OverlayOrchestrator";
import { AdjustBanner } from "./AdjustBanner";
import { CustomBanner } from "./CustomBanner";
export const AppBanner = () => {
    const { isWebView } = useEnvironment();
    const shouldInitAdjustBanner = useShouldInitOverlay("adjust-banner");
    const shouldInitCustomBanner = useShouldInitOverlay("custom-banner");
    if (isWebView)
        return null;
    return (_jsxs(_Fragment, { children: [shouldInitAdjustBanner && _jsx(AdjustBanner, {}), shouldInitCustomBanner && createPortal(_jsx(CustomBanner, {}), document.body)] }));
};
